import React from "react"
import { Link } from "gatsby"
import MailchimpComponent from './mailchimp'
import "./css/styles.css"

const Footer = () => {
    return (
        <nav className="mt-16 sans-serif text-white px-4 sm:px-6 xl:px-6 pb-24 text-md bg-dark-blue">
            <div className="container mx-auto mt-12">
                <div className="block flex-grow lg:flex lg:w-auto space-y-8 lg:space-y-0">
                    <div className="lg:flex-grow">
                        <h2 className="font-bold mb-2">
                            <Link to="/about-us/">About Us</Link>
                        </h2>
                        <ul className="m-0 space-y-2">
                            <li><Link to="/staff-listing/">Our Staff</Link></li>
                            <li><Link to="/join-us/">Join Our Team</Link></li>
                            {/*<li><Link to="/write-for-us/">Write For Us</Link></li>*/}
                        </ul>
                    </div>
                    <div className="lg:flex-grow">
                        <h2 className="font-bold mb-2">
                            <Link to="/contact/">Contact Us</Link>
                        </h2>
                        <ul className="m-0 space-y-2">
                            <li><Link to="/donate-and-subscribe/">Donate and Subscribe</Link></li>
                        </ul>
                    </div>
                    <div className="lg:flex-grow">
                        <h2 className="font-bold mb-2">
                            <Link to="/writing-resources/">Writing Resources</Link>
                        </h2>
                    </div>
                    {/* Removed broken "Notice something wrong?" link */}
                    <div className="lg:flex-shrink max-w-sm">
                        <div className="lg:flex-grow mb-8 lg:mb-12">
                            <h2 className="font-bold mb-2">Follow</h2>
                            <div className="flex flex-row space-x-4 align-items-center">
                                <a href="https://www.instagram.com/berkeleyscirev/" className="flex items-center space-x-2 no-underline">
                                   <img
                                    src="/icons/instagram.svg"
                                    alt="Instagram Icon"
                                    width={20}
                                    height={20}
                                    className="inline-block"
                                    />

                                    <span>Instagram</span>
                                </a>
                                <a href="https://bsky.app/profile/berkeleyscirev.bsky.social" className="flex items-center space-x-2 no-underline" target="_blank" rel="noopener noreferrer">
	                            <img
                                     src="/icons/bluesky.svg"
                                     alt="Bluesky Icon"
                                     width={20}
                                     height={20}
                                     className="inline-block"
                                     />
                                  <span>Bluesky</span>
                                </a>
                            </div>
                        </div>
                        <MailchimpComponent />
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Footer;
